import { Header } from "element-ui";


// zh.js
export default {
    route: {
        dashboard: '首页'
    },
    loginPage: {
        title: '网站管理系统',
        username: '用户名',
        password: '密码',
        captcha: "验证码",
        usernameRule: '请输入用户名',
        passwordRule: '请输入密码',
        captchaRule: "请输入验证码",
        captchaError: "验证码错误",
        loginSuccess: "登录成功",
        loginFailed: "登录失败",
        login: '登录',
        switchLangSuccess: '切换成功'
    },
    layout: {
        header: {
            logo: {
                en: "XIATECH",
                zh: "夏溪科技"
            },
            nav: {
                products: '产品中心',
                solutions: '解决方案',
                services: '服务支持',
                about: '关于我们',
                contact: '联系我们'
            },
            search: {
                placeholder_search: '搜索···',
                btn_advancedSearch: '高级搜索',
                btn_search: '搜索',
            }
        }
    }
};